import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/mdxLayouts/ProjectsLayout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`What I chose to use`}</h2>
    <p>{`I am primarily a React developer so I chose to use React and Gatsby for the UI layer of the site. All of the stylings were done using Tailwind CSS and animations using vanilla CSS. While I was initially going to use MDX files for my content management I chose DatoCMS to house my content. This will likely be changed at a later date, but for now, DatoCMS has been working great and has great integration with Netlify and Gatsby Cloud.`}</p>
    <h2>{`Gatsby and React`}</h2>
    <p>{`Gatsby and React are frameworks that I am most comfortable with. The choice for Gatsby over Nextjs was a difficult choice, but in the end, I found that Gatsby would provide more. Gatsby made the time while working on the project much more productive and cut out some basic work that would be done to set up a Nextjs site. Later I may more to Nextjs for features like comments or any other dynamic features.`}</p>
    <h2>{`DatoCMS`}</h2>
    <p>{`If you are a nerd like me I'm sure you're saying "Why would you go with a hosted CMS instead of owning your content!". This is very valid, but the way I see it if you can pull in the data to your site you can pull it out of a CMS. I've been over a few ways I can pull out of DatoCMS if I feel it isn't meeting my need, but the experience DatoCMS provides is far greater than anything I would like to code out. The interface makes editing and writing content far easier than editing and writing markdown files. I don't have to set up an admin dashboard or worry about pushing up content with fields missing and preventing a build. DatoCMS will handle all of that.`}</p>
    <p>{`I know that other markdown editors exist and I have used them on a few client sites, but I found the interface to be extremely clunky and difficult to use at times. Not to mention that setting up YAML files for NetlifyCMS is just a pain. I'm happy with DatoCMS so far and I will make another post if I run into any issues later down the road.`}</p>
    <h2>{`Tailwind CSS`}</h2>
    <p>{`After trying out Tailwind in a previous project I found that the workflow that Tailwind provides fits perfectly with my development style. I was able to easily layout the site with even spacing and dark mode without having to set up the CSS variables I normally would on a project. My favorite feature of Tailwind is definitely how easy it is to integrate dark mode. If you are interested in a quick article going over Tailwind CSS and dark mode I made a post about this combo on my blog.`}</p>
    <h2>{`Conclusion`}</h2>
    <p>{`There are pros and cons to every decision you make while developing and I feel that most of the choices I ended up making worked out for the best. I may end up moving to Git-based CMS down the road, but for now, DatoCMS has been doing a great job. I hope you enjoyed this breakdown and if you would like to start a discussion about the pros and cons of this stack I would love to hear from you.`}</p>

    <style {...{
      "className": "grvsc-styles"
    }}>{`
  .grvsc-container {
    overflow: auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
    padding-top: 1rem;
    padding-top: var(--grvsc-padding-top, var(--grvsc-padding-v, 1rem));
    padding-bottom: 1rem;
    padding-bottom: var(--grvsc-padding-bottom, var(--grvsc-padding-v, 1rem));
    border-radius: 8px;
    border-radius: var(--grvsc-border-radius, 8px);
    font-feature-settings: normal;
    line-height: 1.4;
  }
  
  .grvsc-code {
    display: table;
  }
  
  .grvsc-line {
    display: table-row;
    box-sizing: border-box;
    width: 100%;
    position: relative;
  }
  
  .grvsc-line > * {
    position: relative;
  }
  
  .grvsc-gutter-pad {
    display: table-cell;
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  .grvsc-gutter {
    display: table-cell;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter::before {
    content: attr(data-content);
  }
  
  .grvsc-source {
    display: table-cell;
    padding-left: 1.5rem;
    padding-left: var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem));
    padding-right: 1.5rem;
    padding-right: var(--grvsc-padding-right, var(--grvsc-padding-h, 1.5rem));
  }
  
  .grvsc-source:empty::after {
    content: ' ';
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter + .grvsc-source {
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  /* Line transformer styles */
  
  .grvsc-has-line-highlighting > .grvsc-code > .grvsc-line::before {
    content: ' ';
    position: absolute;
    width: 100%;
  }
  
  .grvsc-line-diff-add::before {
    background-color: var(--grvsc-line-diff-add-background-color, rgba(0, 255, 60, 0.2));
  }
  
  .grvsc-line-diff-del::before {
    background-color: var(--grvsc-line-diff-del-background-color, rgba(255, 0, 20, 0.2));
  }
  
  .grvsc-line-number {
    padding: 0 2px;
    text-align: right;
    opacity: 0.7;
  }
  
`}</style>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      